import {getId, getType} from 'apis/model/base'
import {LayoutContext} from 'components/layouts/Default/LayoutContext'
import getTitle from 'helpers/getTitle'
import _ from 'lodash'
import {useAppConfig} from 'modules/local/AppConfigContext'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext, useMemo} from 'react'
import {ConversationWith} from 'views/AppLocals/factory/createChatButton'
import {FlexCol} from 'views/AppLocals/Templates/ItemTemplate'
import {getFullAddress, getResponseItems, renderIf, renderMail, renderPhone, renderSelf,} from 'views/Shared'
import OrganizationContainerContext from '../OrganizationContainerContext'
import {PiChatsFill, PiPhoneCallFill} from "react-icons/pi";
import {GoDotFill} from "react-icons/go";
import {TbBrandYoutubeFilled} from "react-icons/tb";
import {WrapperBlockSider} from "../components/WrapperBlockSider";
import {SiderBlockHeader} from "../components/SiderBlockHeader";
import {SiderBlockCard} from "../components/SiderBlockCard";
import {HiOutlineExternalLink, HiRss} from "react-icons/hi";
import {BsFacebook, BsInstagram, BsLinkedin, BsPinMapFill, BsTelephoneFill, BsTiktok, BsTwitterX} from "react-icons/bs";
import {IoEarth, IoStorefront} from "react-icons/io5";
import {scrollToRow} from "../../Missal/functions/scrollToRow";
import getLinkToDetail from "../../../../helpers/getLinkToDetail";
import {FiChevronsRight} from "react-icons/fi";
import {useHistory} from "../../../../modules/navigation/useRouter";
import {FaBoxOpen, FaPhone} from "react-icons/fa6";
import Toggle from "../../../../components/Toggle";
import useAsync from "../../../../modules/asyncCache/useAsync";
import {host_getPeerMembers_Api, host_getsByHost_api, host_getsbyOwner_api} from "../../../../apis";
import {bindQueryParams} from "../../functions/routerHelper";
import {Avatar} from "antd";
import {SearchGroupIcon} from "../../../../components/AppIcon";
import {Link} from "react-router-dom";
import {OrgType} from "../components/OrgType";
import {AppLogoSvg} from "../../../../appConfigs/svgs/AppLogoSvg";
import {ImagePlaceholder} from "../../../../conts/imageBase64";
import {SiZalo} from "react-icons/si";
import {ItemInfoWithIcon} from "../../../../components/common/ItemInfoWithIcon";
import {ItemInformation} from "../../../../components/common/ItemInformation";
import EmptyHolder from "../../../../components/EmptyHolder";

const ItemInfo = ({label, value, primary = false, showIcon = false}) => {
    const t = useTranslate()

    return (renderIf(
        Boolean(value),
        <div className="space-x-1 text-xs">
            {renderIf(
                showIcon === true,
                <GoDotFill size={10} className="text-color-400"/>
            )}
            <span className="text-color-500 italic">
                {`${t(label)} : `}
            </span>
            <span className={primary === true ? 'font-bold text-color-000' : 'font-semibold text-color-100'}>
                {value}
            </span>
        </div>
    ))
}

const ContactFooter = ({item, title,}) => {

    const t = useTranslate()
    const {role_titles = []} = useAppConfig('role_titles')

    return (
        <div className="flex flex-col flex-1 gap-1">
            {[
                {
                    name: 'prefix_name',
                    label: 'representative',
                    primary: true,
                    transform: (value) => [value !== '...' ? t(value) : null, title].join(' '),
                },
                {
                    name: 'role_title',
                    label: 'position',
                    transform: (value) => _.get(role_titles, value),
                },
                {
                    name: 'phone',
                    label: 'phone',
                    transform: renderPhone,
                },
                {
                    name: 'phone2',
                    label: 'alternative phone',
                    transform: renderPhone,
                },
                {
                    name: 'email',
                    label: 'email',
                    transform: renderMail,
                },
            ].map(({name, label, primary, transform = renderSelf}, index) => (
                <ItemInfo
                    showIcon={true}
                    key={index}
                    label={label}
                    value={transform(_.get(item, name))}
                    primary={primary}
                    className="text-xs tracking-wider"
                />
            ))}
        </div>
    )
}

const ContactActions = ({phone, contact_member, organization_id}) => {

    const t = useTranslate()
    const {isSm} = useContext(LayoutContext)
    const {user} = contact_member || {}

    return (
        <div className="flex flex-col gap-3 md:gap-1">
            {contact_member && (
                <ConversationWith
                    params={{receiver_id: getId(user)}}
                    render={(__, {onClick}) => (
                        <div
                            onClick={onClick}
                            style={{minHeight: 36, padding: '4px 12px', cursor: 'pointer'}}
                            className="flex flex-center gap-2 bg-blue-100 hover:bg-blue-100 rounded-md font-medium text-blue-600 hover:text-blue-700">
                            <PiChatsFill size={16}/>
                            {!isSm && t('send message')}
                        </div>
                    )}
                />
            )}
            {renderPhone(
                phone,
                (value) => (
                    <div
                        style={{minHeight: 36, padding: '4px 12px', cursor: 'pointer'}}
                        className="flex flex-center gap-2 bg-blue-100 hover:bg-blue-100 rounded-md font-medium text-blue-600 hover:text-blue-700">
                        <PiPhoneCallFill size={16}/>
                        {!isSm && value}
                    </div>
                ),
                ({href, children}) => (
                    <a
                        href={href}
                        className="no-underline">
                        {children}
                    </a>
                )
            )}
        </div>
    )
}

const ContactInfo = ({organization_id, ...contact}) => {

    const {location} = contact || {}

    if (_.isEmpty(contact)) return null

    return (
        <div className="p-3 border border-color-50 shadow-sm hover:shadow-md background rounded-xl hover:scale-3xs">
            <div className="flex-1 font-bold text-base md:text-lg text-blue-700 leading-snug tracking-wider">
                {_.get(location, 'location_name')}
            </div>
            <div className="mt-1 flex items-start gap-3">
                <ContactFooter
                    item={_.pick(contact, [
                        'email',
                        'phone',
                        'phone2',
                        'role_title',
                        'prefix_name',
                    ])}
                    title={getTitle(contact)}
                />
                <ContactActions
                    phone={_.get(contact, 'phone') || _.get(contact, 'phone2')}
                    contact_member={_.get(contact, 'contact_member')}
                    organization_id={organization_id}
                />
            </div>
        </div>
    )
}

export const OrganizationLinkedPageBlock = ({}) => {
    const t = useTranslate()
    const {isLg} = useContext(LayoutContext)
    const {organization} = useContext(OrganizationContainerContext)
    const website = _.get(organization, 'website')
    const video_url = _.get(organization, 'video_url')
    const linkPage = _.get(organization, 'linked_pages', [])

    const IconPage = ({page, url, size}) => {
        const u = (url || '').toLowerCase()

        if (u.includes('facebook.com')) return <BsFacebook size={size} className="text-blue-800"/>
        if (u.includes('linkedin.com')) return <BsLinkedin size={size} className="text-blue-600"/>
        if (u.includes('twitter.com') || u.includes('x.com')) return <BsTwitterX size={size} className="text-color-000"/>
        if (u.includes('instagram.com')) return <BsInstagram size={size} className="text-orange-500"/>
        if (u.includes('youtube.com') || u.includes('youtu.be')) return <TbBrandYoutubeFilled size={size} className="text-red-600"/>
        if (u.includes('tiktok.com')) return <BsTiktok size={size} className="text-color-000"/>
        if (u.includes('zalo.me')) return <SiZalo size={size} className="text-blue-500"/>

        // URL nội bộ kristo.network → dùng logo app
        if (u.includes('kristo.network')) return <AppLogoSvg size={size}/>

        // fallback: globe icon thay vì link icon
        return <IoEarth size={size} className="text-gray-400"/>
    }

    return (
        <WrapperBlockSider
            title="official page of the Community" titleColor="text-indigo-700"
            borderLeft={isLg}
            borderTop={!isLg}
            icon={<HiRss size={18} className="text-indigo-500"/>}>
            {_.some([website !== '', video_url, linkPage.length > 0]) && (
                <div className="mt-3 flex flex-col gap-2">
                    {linkPage.length > 0 && (
                        linkPage.map((e, i) => (
                            <a
                                key={i}
                                href={e.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="flex items-center gap-3 px-3 py-2 rounded-xl border border-gray-100 hover:border-indigo-200 hover:bg-indigo-50 transition-all no-underline group">
                                <div className="flex-shrink-0">
                                    <IconPage page={e.page} url={e.url} size={22}/>
                                </div>
                                <div className="flex flex-col min-w-0">
                                    <span className="font-semibold text-sm text-gray-800 group-hover:text-indigo-700 leading-snug truncate">
                                        {e.page}
                                    </span>
                                    <span className="text-xs text-gray-400 truncate leading-snug">
                                        {e.url.replace(/^https?:\/\//, '')}
                                    </span>
                                </div>
                                <HiOutlineExternalLink size={14} className="ml-auto flex-shrink-0 text-gray-300 group-hover:text-indigo-400 transition-colors"/>
                            </a>
                        ))
                    )}
                    {_.get(organization, 'video_url') && (
                        <a
                            href={_.get(organization, 'video_url')}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center gap-3 px-3 py-2 rounded-xl border border-gray-100 hover:border-red-200 hover:bg-red-50 transition-all no-underline group">
                            <div className="flex-shrink-0">
                                <TbBrandYoutubeFilled size={22} className="text-red-600"/>
                            </div>
                            <div className="flex flex-col min-w-0">
                            <span className="font-semibold text-sm text-gray-800 group-hover:text-red-700 leading-snug">
                                YouTube
                            </span>
                                <span className="text-xs text-gray-400 truncate leading-snug">
                                {_.get(organization, 'video_url').replace(/^https?:\/\//, '')}
                            </span>
                            </div>
                            <HiOutlineExternalLink size={14}
                                                   className="ml-auto flex-shrink-0 text-gray-300 group-hover:text-red-400 transition-colors"/>
                        </a>
                    )}
                    {website && (
                        <a
                            href={website}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center gap-3 px-3 py-2 rounded-xl border border-gray-100 hover:border-indigo-200 hover:bg-indigo-50 transition-all no-underline group">
                            <div className="flex-shrink-0">
                                <IoEarth size={22} className="text-indigo-500"/>
                            </div>
                            <div className="flex flex-col min-w-0">
                            <span
                                className="font-semibold text-sm text-gray-800 group-hover:text-indigo-700 leading-snug">
                                Website
                            </span>
                                <span className="text-xs text-gray-400 truncate leading-snug">
                                {website.replace(/^https?:\/\//, '')}
                            </span>
                            </div>
                            <HiOutlineExternalLink size={14}
                                                   className="ml-auto flex-shrink-0 text-gray-300 group-hover:text-indigo-400 transition-colors"/>
                        </a>
                    )}
                </div>
            )}
        </WrapperBlockSider>
    )
}

export const OrganizationShopsBlock = ({}) => {
    const t = useTranslate()
    const {isLg} = useContext(LayoutContext)
    const {organization} = useContext(OrganizationContainerContext)
    const {shops = []} = organization || {}

    if (shops?.length === 0) return null;

    // Trước đây khối này KHÔNG có khung thẻ nào cả ở cả 2 ngữ cảnh (khác các khối anh em khác đều có
    // background/bo góc/bóng đổ) - giờ đồng bộ: có khung thẻ riêng trên sidebar desktop (SiderBlockCard,
    // isLg), hoà vào trang trên mobile (như OrganizationChurchOrAnnouncement/OrganizationUpcomingEventBlock).

    return (
        <SiderBlockCard>
            <SiderBlockHeader
                icon={IoStorefront}
                iconBgClassName="bg-secondary-50"
                iconColorClassName="text-secondary-500"
                title={t('shops')}
            />
            {shops.map((shop, shopIndex) => {
                return (
                    <Link
                        key={shopIndex} aria-label={getTitle(shop)} to={getLinkToDetail(shop)}
                        className="no-underline">
                        <div className="min-h-40 flex flex-col background-50 hover:shadow-md hover:scale-2xs rounded-xl relative">
                            {/* Banner Image Area */}
                            {shop?.avatar ? (
                                <div
                                    className="border-b border-color-100 rounded-t-2xl bg-no-repeat relative"
                                    style={{
                                        height: 150,
                                        backgroundImage: `url(${shop?.avatar}), url(${ImagePlaceholder})`,
                                        backgroundPosition: 'center',
                                        backgroundSize: 'cover',
                                    }}>
                                    {/* Lớp phủ gradient nhẹ để đảm bảo text dễ đọc ở phía dưới */}
                                    <div className="absolute inset-x-0 top-0 h-80 bg-gradient-to-t from-black/20 to-transparent"/>
                                </div>
                            ) : (
                                <div className="py-6 flex flex-center flex-1 background-200 border-b border-color-100 rounded-t-2xl">
                                    <IoStorefront size={60} style={{color: '#dedede'}}/>
                                </div>
                            )}
                            {/* Content Area */}
                            <div className="p-3 w-full flex flex-col justify-center">
                                {/* Shop Name */}
                                <h2 className="mb-1 flex items-center max-lines-1">
                                    <IoStorefront size={16} className="mr-2 text-indigo-500"/>
                                    <span className="flex-1 font-bold text-base tracking-wider">
                                        {getTitle(shop)}
                                    </span>
                                </h2>
                                {/* Product Count */}
                                <div className="flex items-center">
                                    <FaBoxOpen size={16} className="mr-2 text-color-500"/>
                                    <span
                                        className="space-x-1 font-medium text-xs text-color-100 italic tracking-wider">
                                        <strong>{shop?.product_count?.toLocaleString('vi-VN')}</strong>
                                        <span className="text-color-200">
                                            {t('products').toLowerCase()}
                                        </span>
                                    </span>
                                </div>

                            </div>
                        </div>
                    </Link>
                )
            })}
        </SiderBlockCard>
    )

}

export const OrganizationContactSider = ({}) => {
    const t = useTranslate()
    const {organization} = useContext(OrganizationContainerContext)
    const contacts = Array.from(organization?.contacts || [])
    const history = useHistory()

    if (contacts.length === 0) return null

    // Trước đây dùng background-50 (gần như trùng màu nền trang - phản hồi thực tế: "background màu
    // khác") - giờ tách tông bg-blue-50/border-blue-100, đồng bộ với màu đã dùng cho action liên hệ
    // (nhắn tin/gọi điện) ở ContactActions bên trên cùng file, và chuyển sang khung SiderBlockCard +
    // SiderBlockHeader (pattern chung của mọi khối sidebar khác - xem OrganizationShopsBlock cùng
    // file) thay vì WrapperBlockSider kiểu cũ. Đặt CUỐI sidebar (xem OrganizationSider.js) vì đây là
    // thông tin tra cứu phụ, không phải hành động chính người dùng cần thấy ngay.
    return (
        <SiderBlockCard>
            <SiderBlockHeader
                icon={BsTelephoneFill}
                iconBgClassName="bg-blue-50"
                iconColorClassName="text-blue-500"
                title={t('contact')}
            />
            <div className="flex flex-col gap-3">
                {contacts.slice(0, 3).map((e, i) => {
                    const {location, prefix_name, name, phone, phone2} = e ?? {}
                    const address = getFullAddress(location)

                    return (
                        <div key={i} className="px-3 py-2 bg-slate-50 hover:shadow-md rounded-xl transition-all duration-300">
                            {location && (
                                <div className="mb-2 pb-2 border-b border-blue-100 font-bold text-base text-color-000 tracking-wide leading-tight max-lines-2">
                                    {location.location_name}
                                </div>
                            )}
                            <div className="flex flex-col gap-1">
                                <span className="font-bold text-gray-700 capitalize">
                                    {`${prefix_name !== '...' ? t(prefix_name) : ''} ${name}`}
                                </span>
                                {(phone || phone2) && (
                                    <ItemInfoWithIcon
                                        icon={<FaPhone size={10} className="text-green-600"/>}
                                        value={phone || phone2}
                                        className="text-xs italic"
                                    />
                                )}
                                {address && (
                                    <ItemInfoWithIcon
                                        icon={<BsPinMapFill size={10} className="text-green-600"/>}
                                        value={address}
                                        className="text-xs italic"
                                    />
                                )}
                            </div>
                        </div>
                    )
                })}
                {contacts.length > 3 && (
                    <div className="justify-end">
                        <span
                            className="flex items-center justify-end gap-1 text-color-300 hover:text-color-100 cursor-pointer"
                            onClick={() => {
                                scrollToRow('contentOrg');
                                history.push(getLinkToDetail(organization) + '/contacts')
                            }}>
                            <span className="text-xs italic">
                                {t('see more')}
                            </span>
                            <FiChevronsRight size={13} className="my-auto"/>
                        </span>
                    </div>
                )}
            </div>
        </SiderBlockCard>
    )
}

const OrganizationContactInfo = ({Wrapper = FlexCol}) => {
    const t = useTranslate()
    const {organization} = useContext(OrganizationContainerContext)

    const contacts = Array.from(organization?.contacts || [])
    const organization_id = getId(organization)
    const {locations = []} = organization ?? {}

    const body = useMemo(
        () =>
            contacts.map((contact, index) => (
                <ContactInfo
                    key={index}
                    {...contact}
                    organization_id={organization_id}
                />
            )),
        [contacts, organization_id]
    )

    const {response: coHosts,} = useAsync({
        apiInfo: host_getsbyOwner_api,
        query: bindQueryParams([{id: getId(organization)}, {prop: getType(organization)}]),
        values: {host_type: "organization"}
    })

    const {response: members,} = useAsync({
        apiInfo: host_getsByHost_api,
        query: bindQueryParams([{id: getId(organization)}, {prop: getType(organization)}]),
        values: {owner_type: "organization"}
    })

    const {response: peerMembers,} = useAsync({
        apiInfo: host_getPeerMembers_Api,
        query: bindQueryParams([{id: getId(organization)}, {prop: getType(organization)}]),
    })

    const coHostList = getResponseItems(coHosts)
    const memberList = getResponseItems(members)
    const peerMemberList = getResponseItems(peerMembers)


    const renderItemOrg = (item, index) => (
        <div key={index}
             className="p-2 flex items-center gap-2 border border-color-50 background shadow rounded-xl hover:scale-2xs cursor-pointer">
            <Avatar
                size={40}
                src={item.avatar}
                icon={<SearchGroupIcon size={20} type={getType(item)} className="text-color-500"/>}
                className="flex flex-center background-200 rounded-md"
            />
            <div className="flex flex-col flex-1">
                <Link to={getLinkToDetail(item)} className="font-bold tracking-wide no-underline max-lines-1">
                    {getTitle(item)}
                </Link>
                {getType(item) === 'organization' ? (
                    <OrgType item={item} className="font-medium text-xs text-blue-500 italic"/>
                ) : (
                    <span className="font-medium text-xs text-indigo-500 italic">
                        {t(getType(item))}
                    </span>
                )}
            </div>
        </div>
    )

    if (!contacts || !locations || coHostList?.length === 0 || memberList?.length === 0 || peerMemberList?.length === 0) return <EmptyHolder />

    return (
        <Wrapper className="items-start space-y-6">
            {contacts.length > 0 && (
                <div className="w-full flex flex-col gap-3">
                    <div className="flex flex-col flex-1">
                        <div className="font-semibold text-lg text-gray-800 tracking-wide">
                            {t('contact information')}
                        </div>
                        <div className="w-20 h-1 rounded-full bg-gray-400"/>
                    </div>
                    {body}
                </div>
            )}

            {locations.length > 0 && (
                <div className="w-full flex flex-col gap-3">
                    <div className="flex flex-col flex-1">
                        <div className="font-semibold text-lg text-gray-800 tracking-wide">
                            {t('locations')}
                        </div>
                        <div className="w-20 h-1 rounded-full bg-gray-400"/>
                    </div>
                    {locations.map((e, i) => {
                        const {location_name, postal_code} = e ?? {}
                        const address = getFullAddress(e)

                        return (
                            <div key={i} className="px-3 py-2 flex flex-col gap-1 background shadow-sm rounded-xl">
                                <span className="font-bold text-color-000 uppercase">
                                    {location_name}
                                </span>
                                <div className="flex flex-col gap-1">
                                    <ItemInformation showIcon={true} label="address" value={address} className="text-xs tracking-wider"/>
                                    {renderIf(
                                        postal_code,
                                        <ItemInformation showIcon={true} label="postal code" value={postal_code} className="text-xs tracking-wider"/>
                                    )}
                                </div>
                            </div>
                        )
                    })}
                </div>
            )}

            {/* Đơn vị liên quan */}
            {(coHostList.length > 0 || memberList.length > 0 || peerMemberList.length > 0) && (
                <div className="w-full flex flex-col gap-3">
                    <div className="flex flex-col flex-1">
                        <div className="font-semibold text-lg text-gray-800 tracking-wide">
                            {t('related organization')}
                        </div>
                        <div className="w-20 h-1 rounded-full bg-gray-400"/>
                    </div>
                    {coHostList.length > 0 && (
                        <Toggle>
                            {(isToggle, toggle) => (
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    {coHostList.slice(0, isToggle ? coHostList.length : 4).map((e, i) => (renderItemOrg(e?.host, i)))}
                                    {coHostList.length > 4 && (
                                        <span
                                            className="col-span-1 md:col-span-2 flex items-center justify-end gap-1 text-color-400 hover:text-color-100 cursor-pointer"
                                            onClick={() => {
                                                toggle()
                                            }}>
                                        <span className="text-xs italic">
                                            {isToggle ? t('see less') : t('see more')}
                                        </span>
                                        <FiChevronsRight size={13} className="my-auto"/>
                                    </span>
                                    )}
                                </div>
                            )}
                        </Toggle>
                    )}
                    {memberList.length > 0 && (
                        <Toggle>
                            {(isToggle2, toggle2) => (
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    {memberList.slice(0, isToggle2 ? memberList.length : 4).map((e, i) => (renderItemOrg(e?.owner, i)))}
                                    {memberList.length > 4 && (
                                        <span
                                            className="col-span-1 md:col-span-2 flex items-center justify-end gap-1 text-color-400 hover:text-color-100 cursor-pointer"
                                            onClick={() => {
                                                toggle2()
                                            }}>
                                            <span className="text-xs italic">
                                                {isToggle2 ? t('see less') : t('see more')}
                                            </span>
                                            <FiChevronsRight size={13} className="my-auto"/>
                                        </span>
                                    )}
                                </div>
                            )}
                        </Toggle>
                    )}
                    {peerMemberList.length > 0 && (
                        <Toggle>
                            {(isToggle3, toggle3) => (
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    {peerMemberList.slice(0, isToggle3 ? peerMemberList.length : 4).map((e, i) => (renderItemOrg(e?.owner, i)))}
                                    {peerMemberList.length > 4 && (
                                        <span
                                            className="col-span-1 md:col-span-2 flex items-center justify-end gap-1 text-color-400 hover:text-color-100 cursor-pointer"
                                            onClick={() => {
                                                toggle3()
                                            }}>
                                            <span className="text-xs italic">
                                                {isToggle3 ? t('see less') : t('see more')}
                                            </span>
                                            <FiChevronsRight size={13} className="my-auto"/>
                                        </span>
                                    )}
                                </div>
                            )}
                        </Toggle>
                    )}
                </div>
            )}
        </Wrapper>
    )
}

export default OrganizationContactInfo
